module.exports = __webpack_public_path__ + "img/rent-safe.1671ba8c.svg";